export default function NotReadyProcurementIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <g clipPath="url(#clip0_30500_7198)">
        <path
          d="M10.4655 4.84346C10.1493 4.62296 9.79679 4.45103 9.41871 4.33851V2.61667H5.01497L3.96822 1.56993H1.04479V8.89712H4.8601C4.97263 9.2752 5.14456 9.62774 5.36505 9.94386H0.521417C0.23237 9.94386 -0.00195312 9.70954 -0.00195312 9.42049V1.04656C-0.00195312 0.757517 0.23237 0.523193 0.521417 0.523193H4.40179L5.44853 1.56993H9.94208C10.2311 1.56993 10.4655 1.80426 10.4655 2.0933V4.84346Z"
          fill="black"
        />
      </g>
      <circle
        cx="8.14479"
        cy="7.58961"
        r="2.44224"
        stroke="black"
        strokeWidth="0.825022"
      />
      <line
        x1="8.07853"
        y1="6.3335"
        x2="8.07853"
        y2="8.1415"
        stroke="black"
        strokeWidth="0.825022"
      />
      <line
        x1="9.56934"
        y1="7.74601"
        x2="7.66608"
        y2="7.74601"
        stroke="black"
        strokeWidth="0.825022"
      />
      <defs>
        <clipPath id="clip0_30500_7198">
          <rect width="10.4674" height="10.4674" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
